import React from "react";
import getConfig from "next/config";

import Typography from "@components/shared/Typography";
import { LinkButton } from "@components/shared/Button";

import { useTranslation } from "@lib/i18n";

const { publicRuntimeConfig } = getConfig();
const { ROOT_URL_PREFIX } = publicRuntimeConfig;

const TestDriveUnavailable = () => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col justify-center items-center gap-8 bg-primaryLight px-8 py-16 lg:p-20 min-h-[calc(100dvh-7.5rem-1px)]">
      <div className="flex flex-col justify-center items-center gap-8 uppercase lg:p-8">
        <h1 className="text-4xl text-primaryDark font-bold text-center text-balance uppercase">
          {t("testDrive.unavailable.title")}
        </h1>
        <Typography className="text-center text-balance">
          {t("testDrive.unavailable.message")}
        </Typography>
        <LinkButton href={ROOT_URL_PREFIX || "/"}>
          {t("testDrive.unavailable.goToHome")}
        </LinkButton>
      </div>
    </div>
  );
};

export default TestDriveUnavailable;
